import React, { useEffect, useState, useContext, useRef } from 'react';
import { Grid } from '@mui/material';
import { AppContext } from '../../context/Context';
import { useTranslation } from 'react-i18next';
import { SocketContext } from '../../context/SocketContext';

import '../../assets/css/buttons.css';

import toast from 'react-hot-toast';

import { useNavigate } from 'react-router-dom';
import SummaryTable from './SummaryTable';
import SummaryTableTickets from './SummaryTableTickets';
import SummarySkeleton from './SummarySkeleton';

import {
  Bedtime as BedTimeIcon,
  ReceiptLong as ReceiptLongIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
} from '@mui/icons-material/';

function AvslutteSkiftet() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const {
    hall,
    operator,
    session,
    updateShowModalEndShift,
    isDailyReportCompleted,
    isCardReportCompleted,
    updateIsDailyReportCompleted,
    updateIsCardReportCompleted,
    printer,
    isWGReportCompleted,
    updateIsWGReportCompleted,
    isWGEnabled,
    isBlocking,
    isLoadingScreen,
    updateIsLoadingScreen,
    isLogin,
    BlockingScreen,
    enviroment,
    modifyLogin,
    modifyOperator,
    modifyOperatorFull,
    modifyHall,
    updateSession,
  } = useContext(AppContext);

  //* Redirect to login if not logged in
  useEffect(() => {
    if (!isLogin) {
      navigate('/login');
    }
  }, []);

  const inputRef = useRef(null);
  useEffect(() => {
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 1400);

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const hallRef = useRef(hall);

  useEffect(() => {
    hallRef.current = hall;

    socket.emit('closeShiftNumbers', {
      action: 'closeShiftNumbers',
      bingoName: hallRef.current,
      sessionID: sessionRef.current,
    });
  }, [hall]);

  const operatorRef = useRef(operator);
  useEffect(() => {
    operatorRef.current = operator;
  }, [operator]);

  const sessionRef = useRef(session);
  useEffect(() => {
    sessionRef.current = session;
  }, [session]);

  const printerRef = useRef(printer);
  useEffect(() => {
    printerRef.current = printer;
  }, [printer]);

  const enviromentRef = useRef(enviroment);
  useEffect(() => {
    enviromentRef.current = enviroment;
  }, [enviroment]);

  useEffect(() => {
    if (!isWGEnabled) {
      updateIsWGReportCompleted(true);
    }
  }, [isWGEnabled]);

  const { socket } = useContext(SocketContext);

  const [isLoading, setIsLoading] = useState(true);
  const [numbers, setNumbers] = useState(false);
  const [tickets, setTickets] = useState(false);

  const [showCloseOpenTicketsModal, setShowCloseOpenTicketsModal] =
    useState(false);
  const updateShowCloseOpenTicketsModal = (value) => {
    setShowCloseOpenTicketsModal(value);
  };

  const [showCloseOpenTicketsModalDone, setShowCloseOpenTicketsModalDone] =
    useState(false);
  const updateShowCloseOpenTicketsModalDone = (value) => {
    setShowCloseOpenTicketsModalDone(value);
  };

  const [showCloseSessionModal, setShowCloseSessionModal] = useState(false);
  const updateShowCloseSessionModal = (value) => {
    setShowCloseSessionModal(value);
  };

  const [showCloseSessionModalDone, setShowCloseSessionModalDone] =
    useState(false);
  const updateShowCloseSessionModalDone = (value) => {
    setShowCloseSessionModalDone(value);
  };

  useEffect(() => {
    const handleCloseShiftNumbers = (data) => {
      if (!data) {
        toast.error(t('error.error'));
        return;
      }
      setNumbers(data);
      setTickets(data.openTickets);
      setIsLoading(false);
    };

    const handleCloseShiftTickets = (data) => {
      if (!data) {
        toast.error(t('error.error'));
        return;
      }
      setNumbers(data);
      setTickets(data.openTickets);
      updateShowCloseOpenTicketsModal(false);
      updateShowCloseOpenTicketsModalDone(true);
      updateIsLoadingScreen(false);
    };

    const handleCloseShift = (data) => {
      if (!data) {
        toast.error(t('error.error'));
        return;
      }
      updateIsLoadingScreen(false);
      updateShowCloseSessionModal(false);
      updateShowCloseSessionModalDone(true);
    };

    socket.on('closeShiftNumbers', handleCloseShiftNumbers);
    socket.on('closeShiftTickets', handleCloseShiftTickets);
    socket.on('closeShift', handleCloseShift);

    return () => {
      socket.off('closeShiftNumbers', handleCloseShiftNumbers);
      socket.off('closeShiftTickets', handleCloseShiftTickets);
      socket.off('closeShift', handleCloseShift);
    };
  }, [socket]);

  const handleCloseShift = () => {
    updateIsLoadingScreen(true);

    socket.emit('closeShift', {
      action: 'closeShift',
      bingoName: hallRef.current,
      sessionID: sessionRef.current,
      operator: operatorRef.current,
      printer: printerRef.current,
      enviroment: enviromentRef.current,
    });
  };

  const handleCloseOpenTickets = () => {
    updateIsLoadingScreen(true);
    socket.emit('closeShiftTickets', {
      action: 'closeShiftTickets',
      bingoName: hallRef.current,
      sessionID: sessionRef.current,
      printer: printerRef.current,
      operator: operatorRef.current,
    });
  };

  const ConfirmMessageCloseTickets = () => {
    return (
      <div id="react-confirm-alert">
        <div className="react-confirm-alert-overlay">
          <div className="react-confirm-alert">
            <div
              className="react-confirm-alert-body"
              style={{ width: '1000px' }}
            >
              <h1>{t('avslutteSkiftet.closeOpenTicketsTitle')}</h1>

              <>
                <p>{t('avslutteSkiftet.closeOpenTicketsText1')}</p>
                <p>
                  <strong>{t('avslutteSkiftet.closeOpenTicketsText2')}</strong>
                </p>
                <p>{t('avslutteSkiftet.closeOpenTicketsText3')}</p>

                <div className="react-confirm-alert-button-group">
                  <button
                    className="btn-custom-yes"
                    onClick={() => {
                      handleCloseOpenTickets();
                    }}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px', // Space between icon and text
                    }}
                  >
                    <CheckCircleIcon style={{ fontSize: '1.2em' }} />

                    {t('sales.confirm')}
                  </button>

                  <button
                    className="btn-custom-no"
                    onClick={() => {
                      updateShowCloseOpenTicketsModal(false);
                    }}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px', // Space between icon and text
                    }}
                  >
                    <CancelIcon style={{ fontSize: '1.2em' }} />

                    {t('sales.cancel')}
                  </button>
                </div>
              </>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const ConfirmMessageCloseTicketsDone = () => {
    return (
      <div id="react-confirm-alert">
        <div className="react-confirm-alert-overlay">
          <div className="react-confirm-alert">
            <div
              className="react-confirm-alert-body"
              style={{ width: '1000px' }}
            >
              <h1>{t('avslutteSkiftet.closeOpenTicketsTitle')}</h1>

              <>
                <p>{t('avslutteSkiftet.closeOpenTicketsConfirm')}</p>

                <div className="react-confirm-alert-button-group">
                  <button
                    className="btn-custom-yes"
                    onClick={() => {
                      updateShowCloseOpenTicketsModalDone(false);
                    }}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px', // Space between icon and text
                    }}
                  >
                    <CheckCircleIcon style={{ fontSize: '1.2em' }} />

                    {t('sales.confirm')}
                  </button>
                </div>
              </>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const ConfirmMessageCloseSession = () => {
    return (
      <div id="react-confirm-alert">
        <div className="react-confirm-alert-overlay">
          <div className="react-confirm-alert">
            <div
              className="react-confirm-alert-body"
              style={{ width: '1000px' }}
            >
              <h1>{t('avslutteSkiftet.closeTurnTitle')}</h1>

              <>
                <p>{t('avslutteSkiftet.closeTurnText1')}</p>
                <p>
                  <strong>{t('avslutteSkiftet.closeTurnText2')}</strong>
                </p>

                <div className="react-confirm-alert-button-group">
                  <button
                    className="btn-custom-yes"
                    onClick={() => {
                      handleCloseShift();
                    }}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px', // Space between icon and text
                    }}
                  >
                    <CheckCircleIcon style={{ fontSize: '1.2em' }} />

                    {t('sales.confirm')}
                  </button>

                  <button
                    className="btn-custom-no"
                    onClick={() => {
                      updateShowCloseSessionModal(false);
                    }}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px', // Space between icon and text
                    }}
                  >
                    <CancelIcon style={{ fontSize: '1.2em' }} />

                    {t('sales.cancel')}
                  </button>
                </div>
              </>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const ConfirmMessageCloseSessionDone = () => {
    return (
      <div id="react-confirm-alert">
        <div className="react-confirm-alert-overlay">
          <div className="react-confirm-alert">
            <div
              className="react-confirm-alert-body"
              style={{ width: '1000px' }}
            >
              <h1>{t('avslutteSkiftet.closeTurnConfirm')}</h1>

              <>
                <div className="react-confirm-alert-button-group">
                  <button
                    className="btn-custom-yes"
                    onClick={() => {
                      updateShowCloseSessionModalDone(false);
                      modifyLogin(false);
                      modifyOperator('');
                      modifyOperatorFull('');
                      modifyHall('');
                      updateSession('');
                      navigate('/login');
                    }}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px', // Space between icon and text
                    }}
                  >
                    <CheckCircleIcon style={{ fontSize: '1.2em' }} />

                    {t('sales.confirm')}
                  </button>
                </div>
              </>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {isBlocking && <BlockingScreen />}
      {isLoading ? (
        <SummarySkeleton />
      ) : (
        <Grid
          container
          spacing={2}
          sx={{
            width: '100%',
            height: '100vh', // full viewport height
            p: 2,
            boxSizing: 'border-box',
            overflow: 'auto',
          }}
        >
          <Grid item xs={12}>
            <Grid
              container
              sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              {showCloseOpenTicketsModal && <ConfirmMessageCloseTickets />}
              {showCloseOpenTicketsModalDone && (
                <ConfirmMessageCloseTicketsDone />
              )}
              {showCloseSessionModal && <ConfirmMessageCloseSession />}
              {showCloseSessionModalDone && <ConfirmMessageCloseSessionDone />}
              {/*BUTTONS*/}
              <Grid
                item
                xs={12}
                sx={{
                  width: '100%',
                  height: '200px',
                  maxHeight: '200px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Grid
                  container
                  sx={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    padding: '25px',
                    justifyContent: 'center',
                    alignContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Grid
                    item
                    xs={6}
                    sx={{
                      width: '100%',
                      height: '200px',
                      padding: '25px',
                      margin: '0px 0 20px',
                      borderRadius: '20px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <button
                      className="btn-custom-yes"
                      onClick={() => {
                        updateShowCloseSessionModal(true);
                      }}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px', // Space between icon and text
                      }}
                    >
                      <BedTimeIcon style={{ fontSize: '1.2em' }} />
                      {t('avslutteSkiftet.closeTurn')}
                    </button>
                  </Grid>

                  <Grid
                    item
                    xs={6}
                    sx={{
                      width: '100%',
                      height: '200px',
                      padding: '25px',
                      margin: '0px 0 20px',
                      borderRadius: '20px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <button
                      className="btn-custom-postpone"
                      onClick={() => {
                        if (!tickets || tickets.length === 0) {
                          toast.error(t('avslutteSkiftet.notOpenTickets'));
                          return;
                        }
                        updateShowCloseOpenTicketsModal(true);
                      }}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px', // Space between icon and text
                      }}
                    >
                      <ReceiptLongIcon style={{ fontSize: '1.2em' }} />
                      {t('avslutteSkiftet.closeOpenTicketsBtn')}
                    </button>
                  </Grid>
                </Grid>
              </Grid>

              {/*TABLE*/}
              <Grid
                item
                xs={12}
                sx={{
                  width: '100%',
                  padding: '10px',
                }}
              >
                {numbers && <SummaryTable data={numbers} />}
                {tickets && <SummaryTableTickets data={tickets} />}
              </Grid>
              <Grid
                item
                xs={12}
                sx={{
                  width: '100%',
                  padding: '10px',
                  height: '100%',
                }}
              ></Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
}

export default AvslutteSkiftet;
